export enum Endpoint {
  employee = 'employee',
}
export enum Service {
  employee = 'employeeservice',
}
